import { PLAYGROUND_URL, PLAYGROUND_V2_URL } from '@/constants/misc.constants';

export const isPlayground = () => {
  if (typeof window !== 'undefined') {
    const href = window.location?.href;
    return href?.includes(PLAYGROUND_URL) || href?.includes(PLAYGROUND_V2_URL);
  }

  return false;
};
